// extracted by mini-css-extract-plugin
module.exports =  {"three-d-box":"_2p6jdD2DfqMUxrtToZ5Lsu","forms3":"_2opJMiv5QgVV4yez12I6_f","low":"L2L625xbXHDqHgwTwAxgu","medium":"P1Ea1tsXnzsLAffOe5mvL","clean-button":"_1LcTG1y1oKWac7KKlrqIjg"};